export default class FormDataConverter {

	static convert(dataObject, parentObjectKey='', formData = new FormData()) {
		Object.keys(dataObject).forEach((key) => {
			const value = dataObject[key];
			if(!!parentObjectKey)
				key = FormDataConverter.parseNestedObjectKey(parentObjectKey, key, dataObject);

			if(!!value && typeof value == "object" && !(value instanceof File)) {
				FormDataConverter.convert(value, key, formData);
			} else if(value instanceof File) {
				formData.append(key, value, value.name);
			} else {
				formData.append(key, value);
			}
		});

		return formData;
	}

	static parseNestedObjectKey(parentObjectKey, key, parentObject) {
		if(Array.isArray(parentObject))
			return `${parentObjectKey}[${key}]`;
		else
			return `${parentObjectKey}.${key}`;
	}
}
